<template>
  <div class="tgb-tags">
    <o-field labelClass="tgb-label" label="Tags">
      <o-inputitems
        v-bind="{...$props, ...$attrs}"
        v-on="$listeners"
        iconPack="fas"
        icon="tags"
        placeholder="Add a tag"
        inputClass="tgb-tags__input"
        itemClass="tgbTag"
        expanded
        closeClass="close-tag"
        :rootClass="`tgb-tags__input-container` + (!valid ? ' critical' : '')"
        v-model="innerModel"
        @add="$emit('add');"
        @remove="$emit('remove');"
        @input="$emit('input')"
        @blur="$emit('blur')"
      >
        <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
      </o-inputitems>
    </o-field>

    <p
      class="formFieldError"
      v-if="!valid"
    >
      <span class="fas fa-exclamation-triangle" />
      Tags must be at least 2 characters and must not have special characters.
      <br>
      Remove:
      <span v-for="(tag, i) in invalidTag" key="i">{{ tag }}</span>
    </p>
  </div>
</template>

<script>
const regexs = require('@tagboard/helpers/regexs');

export default {
  name: 'TgbTags',
  inheritAttrs: false,
  props: ['label', 'value'],
  computed: {
    innerModel: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },

    invalidTag() {
      const found = this.innerModel.filter((hashtag) => !regexs.hashtag.test(hashtag));
      this.$emit('invalid', found.length);
      return found;
    },

    valid() {
      return !this.invalidTag.length;
    },
  },
};
</script>

<style lang="scss">
.tgb-tags {
  &__input {
    background: transparent;
    border: none;
    padding-left: 24px;
    outline: none;
  }
}

.close-tag {
  width: 20px;
  height: 20px;
  color: #23CDF4
}
</style>
